import React, { Component } from "react";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import { states } from "../../../reducers/queriesStates";
import styles from "./reportContructor.module.scss";
import ButtonIconWrapper from "../../../shared/items/contols/buttonIconWrapper";
import Preloader from "../../../shared/items/static/preloader";

class ReportConstructorDownloadExcelExample extends Component {
  handleClick() {
    const { onDownloadExampleCustomReport, customReport } = this.props;

    onDownloadExampleCustomReport(customReport);
  }

  render() {
    const { downloadExampleCustomReportDataState } = this.props;

    return downloadExampleCustomReportDataState === states.REQUEST ? (
      <div>
        <Preloader />
      </div>
    ) : (
      <div className={styles.downloadExamleContainer}>
        <ButtonIconWrapper type={"primary"} icon="save" handleClick={this.handleClick.bind(this)} size={20} />
        <div className={styles.downloadExamleTitle}>
          <span>Скачать пример отчета в формате Excel</span>
        </div>
      </div>
    );
  }
}

export default withCustomReport(React.memo(ReportConstructorDownloadExcelExample));
